<template>
  <div class="top-margin">
    <form v-on:submit.prevent>
      <img src="/beamylogo_white.svg" />
      <h2>Choose Station:</h2>
      <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>

      <div :key="station.name" v-for="station in stations">
        <button @click="choose(station)" type="button" class="full-width">{{ station.name }}</button>
      </div>

      <a class="other" @click="signOut">Sign out</a>
    </form>
  </div>
</template>

<script>
import { api } from "@monolith/helpers";

export default {
  name: "ChooseStation",
  data() {
    return {
      errors: {},
      stations: []
    }
  },
  async created() {
    const stationJson = await window.localStorage.getItem("stations");
    const currSite = await localStorage.getItem('site');
    this.stations = JSON.parse(stationJson).filter(
      station => station.site == currSite
    );
  },
  methods: {
    async choose(station) {
      await window.localStorage.setItem("station", station.name);
      const settings = await api.get_site_settings(localStorage.getItem("site"));
      localStorage.setItem("settings", JSON.stringify(settings));
      this.$router.push('/dashboard');
    },
    signOut() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
form {
  border-radius: 0.5rem;
  max-width: 400px;
  padding: 2rem;
  margin: 0px auto;
  margin-top: 1rem;
  background-color: var(--secondary-colour);
  font-size: 1em;

  img { width: 100%; }
  a { color: var(--text-colour); text-decoration: none; cursor: pointer; }

  button {
    margin-bottom: 1rem;
    margin-left: 0px !important;
    padding: 1rem;
    font-weight: bold;
    border-radius: 0.25rem;
    background-color: var(--action-colour);
    color: var(--primary-colour);
    border: none;
  }
}

form div.error {
  color: #ff8197;
  margin-bottom: 1em;
}
</style>
